export default {
  uploads: [],
  upload: [],
  excelTemplateHtml: null,
};
